<div *transloco="let t; prefix: 'shared.errorPage'" class="flex flex-col pt-[104px] pb-14">
	<!-- Bottom Right Image -->
	<div class="flex fixed bottom-0 right-0">
		<img class="rfs:w-[259px] rfs:h-[280px]" src="./assets/img/error-pages/uniko-vector.png" />
	</div>
	<!-- Main Content -->
	<div class="flex-shrink md:flex-grow flex flex-col items-center gap-10 px-4">
		<div class="w-full md:w-auto relative">
			<img class="w-full md:w-auto" src="./assets/img/error-pages/404.png" />
		</div>
		<div class="text-center flex flex-col gap-4">
			<div class="text-black text-[28px] font-normal">{{t('notFound.title')}}</div>
			<div class="text-[#50575f] text-base font-normal"> {{t('notFound.description')}}</div>
		</div>
		<div class="px-5 py-4 bg-primary-500 rounded-2xl">
			<button class="text-black text-base font-semibold" [localizedRouterLink]="['/home']"> {{t('buttonLabel')}}
			</button>
		</div>
	</div>
</div>